define(
	'Digi.DigiConfigSettings.DigiConfigSettings.Shopping',
   	[
		'Digi.DigiConfigSettings.DigiConfigSettings',
		'GoVirtualOffice.HideItemOption.HideItemOption',
		'GoVirtualOffice.LoginOriginRedirect.LoginOriginRedirect'
	],
   	function (
		DigiConfigSettings,
		GoVirtualOfficeHideItemOption,
		GoVirtualOfficeLoginOriginRedirect
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application) {

			DigiConfigSettings.mountToApp(application);
			GoVirtualOfficeHideItemOption.mountToApp(application);
			GoVirtualOfficeLoginOriginRedirect.mountToApp(application);
		}
	};
});
